import React from "react";
import { Button } from "primereact/button";
import { useSidebar } from "../contexts/SidebarContext";

export const TableTitle: React.FC<{ title: string }> = ({ title }) => {
  const { toggleSidebar } = useSidebar();

  return (
    <div className="flex-container">
      <Button
        text
        size="small"
        severity="secondary"
        aria-label="Sidebar menu"
        icon="pi pi-bars"
        className="sidebar-toggle-button"
        onClick={toggleSidebar}
      />
      <h1 className="table-header">{title}</h1>
    </div>
  );
};
